(() => {
  'use strict';
  const menuButton = document.querySelector('.sdc-menu-toggle');
  const menu = document.querySelector('.site-navigation');
  if (menuButton && menu) {
    const closeMenu = () => { menuButton.setAttribute('aria-expanded', 'false'); menu.classList.remove('is-open'); document.body.classList.remove('menu-open'); };
    menuButton.addEventListener('click', () => { const open = menuButton.getAttribute('aria-expanded') === 'true'; menuButton.setAttribute('aria-expanded', String(!open)); menu.classList.toggle('is-open', !open); document.body.classList.toggle('menu-open', !open); });
    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeMenu(); });
  }
  const selectedTitle = document.getElementById('selected-unit-title');
  const selectedMeta = document.getElementById('selected-unit-meta');
  const unitLabel = document.getElementById('unit-label');
  const booking = document.getElementById('booking');
  const firstNameField = document.getElementById('booking-name');
  document.querySelectorAll('.js-select-unit').forEach((button) => button.addEventListener('click', () => {
    const title = button.dataset.unitTitle || '';
    if (selectedTitle) selectedTitle.textContent = title;
    if (selectedMeta) selectedMeta.textContent = `${button.dataset.unitSize || ''} · ${button.dataset.unitPrice || ''} / måned`;
    if (unitLabel) unitLabel.value = title;
    if (booking) { booking.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'}); window.setTimeout(() => firstNameField && firstNameField.focus({preventScroll:true}), 550); }
  }));
})();
